import { Action, Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";

import { AppId, getAppId, UploadBannerContentTypes } from "api";
import { Credentials } from "auth";
import { ClientApp } from "models";
import { State } from "redux/state";

export type UploadBanner = "UPLOAD_BANNER";
export const UPLOAD_BANNER: UploadBanner = "UPLOAD_BANNER";
export type UploadBannerSuccess = "UPLOAD_BANNER_SUCCESS";
export const UPLOAD_BANNER_SUCCESS: UploadBannerSuccess = "UPLOAD_BANNER_SUCCESS";
export type UploadBannerFailure = "UPLOAD_BANNER_FAILURE";
export const UPLOAD_BANNER_FAILURE: UploadBannerFailure = "UPLOAD_BANNER_FAILURE";

export interface UploadBannerAction extends Action {
    payload: {
        credentials: Credentials;
        appId: string;
        blob: Blob;
        contentType: UploadBannerContentTypes;
    };
    type: UploadBanner;
}

export function uploadBanner(
    appId: AppId,
    blob: Blob,
    contentType: UploadBannerContentTypes
): ThunkAction<void, State, undefined, UploadBannerAction> {
    return (dispatch: Dispatch<UploadBannerAction>, getState) => {
        const credentials = getState().auth.credentials;
        dispatch(uploadBannerWithCredentials(credentials, appId, blob, contentType));
    };
}

function uploadBannerWithCredentials(
    credentials: Credentials,
    appId: AppId,
    blob: Blob,
    contentType: UploadBannerContentTypes
): UploadBannerAction {
    return {
        payload: {
            appId: getAppId(appId),
            blob,
            contentType,
            credentials
        },
        type: UPLOAD_BANNER
    };
}

export interface UploadBannerSuccessAction extends Action {
    payload: {
        app: ClientApp;
    };
    type: UploadBannerSuccess;
}

export function uploadBannerSuccess(app: ClientApp): UploadBannerSuccessAction {
    return {
        payload: {
            app
        },
        type: UPLOAD_BANNER_SUCCESS
    };
}

export interface UploadBannerFailureAction extends Action {
    payload: {
        error: Error;
    };
    type: UploadBannerFailure;
}

export function uploadBannerFailure(error: Error): UploadBannerFailureAction {
    return {
        payload: {
            error
        },
        type: UPLOAD_BANNER_FAILURE
    };
}
